import { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getMyWallets } from '../../api/walletApi';
import { getMyReferrals, getLevelUsers } from '../../api/userApi';

const accent = '#cc66ff';
const cardDark = {
  background: 'linear-gradient(135deg, #0d0d0d 0%, #1a0033 100%)',
  color: '#fff',
  border: '1px solid #9933ff44',
};

const StatCard = ({ value, label, valueColor = accent, onClick }) => (
  <Col md={4}>
    <Card style={cardDark} className="p-3 h-100 dashboard-card">
      <Card.Body className="d-flex flex-column">
        <div style={{ fontSize: 28, fontWeight: 800, color: valueColor, marginBottom: 4 }}>
          {value}
        </div>
        <div style={{ color: '#aaa', fontSize: 13, marginBottom: 'auto' }}>{label}</div>
        {onClick && (
          <div className="d-flex justify-content-end mt-3">
            <Button
              size="sm"
              onClick={onClick}
              style={{ background: 'transparent', border: `1px solid ${accent}`, color: accent }}
            >
              View
            </Button>
          </div>
        )}
      </Card.Body>
    </Card>
  </Col>
);

const Dashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [wallets, setWallets] = useState({ main_wallet: null, earning_wallet: null });
  const [referralCount, setReferralCount] = useState(null);
  const [levelUserCount, setLevelUserCount] = useState(null);

  useEffect(() => {
    getMyWallets()
      .then((res) => setWallets(res.data.wallets))
      .catch(() => setWallets({ main_wallet: { balance: 0 }, earning_wallet: { balance: 0 } }));
    getMyReferrals()
      .then((res) => setReferralCount(res.data.count))
      .catch(() => setReferralCount(0));
    getLevelUsers()
      .then((res) => setLevelUserCount(res.data.count))
      .catch(() => setLevelUserCount(0));
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0a', paddingBottom: 40 }}>
      <Container className="pt-4">

        {/* Header */}
        <div className="mb-4">
          <h4 style={{ color: '#fff', fontWeight: 700 }}>Welcome, {user?.name}</h4>
          <div style={{ color: '#aaa', fontSize: 13 }}>Your NanoConnect dashboard</div>
        </div>

        {/* Profile card */}
        <Row className="g-3 mb-2">
          <Col md={4}>
            <Card style={{ ...cardDark, border: '1px solid #9933ff88' }} className="p-3 h-100 text-center dashboard-card">
              <Card.Body>
                <div style={{ fontSize: 16, fontWeight: 700, color: accent, marginBottom: 4 }}>Profile</div>
                <div style={{ color: '#ddd', fontSize: 13, marginBottom: 8 }}>{user?.email}</div>
                {user?.planId ? (
                  <div style={{ color: '#aaa', fontSize: 13 }}>
                    Plan: <strong style={{ color: '#fff' }}>{user.planId.planName}</strong>
                    <span style={{ color: '#66ff99', marginLeft: 6 }}>{user.planAmount} USDT</span>
                  </div>
                ) : (
                  <div className="mt-2">
                    <div style={{ color: '#555', fontSize: 13, marginBottom: 8 }}>No active plan</div>
                    <Button
                      size="sm"
                      onClick={() => navigate('/subscribe')}
                      style={{ background: accent, border: 'none', color: '#000', fontWeight: 600 }}
                    >
                      Subscribe
                    </Button>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>

          {/* Main Wallet */}
          <StatCard
            value={<>{wallets.main_wallet !== null ? wallets.main_wallet?.balance : '—'} <span style={{ fontSize: 14, color: '#aaa', fontWeight: 400 }}>USDT</span></>}
            label="Main Wallet"
            valueColor="#66aaff"
            onClick={() => navigate('/wallet')}
          />

          {/* Earning Wallet */}
          <StatCard
            value={<>{wallets.earning_wallet !== null ? wallets.earning_wallet?.balance : '—'} <span style={{ fontSize: 14, color: '#aaa', fontWeight: 400 }}>USDT</span></>}
            label="Earning Wallet"
            valueColor="#66ff99"
            onClick={() => navigate('/wallet?type=earning')}
          />

          {/* Direct Referrals */}
          <StatCard
            value={referralCount !== null ? referralCount : '—'}
            label="My Direct Referrals"
            valueColor={accent}
            onClick={() => navigate('/referrals')}
          />

          {/* Level Users */}
          <StatCard
            value={levelUserCount !== null ? levelUserCount : '—'}
            label="Level Users"
            valueColor="#ffaa44"
            onClick={() => navigate('/level-users')}
          />

          {/* Global Fastrack */}
          <Col md={4}>
            <Card
              style={{ ...cardDark, border: '1px solid #cc66ff66', cursor: 'pointer' }}
              className="p-3 h-100 dashboard-card"
              onClick={() => navigate('/fastrack')}
            >
              <Card.Body className="d-flex flex-column">
                <div style={{ fontSize: 28, fontWeight: 800, color: accent, marginBottom: 4 }}>
                  Fastrack
                </div>
                <div style={{ color: '#aaa', fontSize: 13, marginBottom: 'auto' }}>
                  Global Fastrack Bonus
                </div>
                <div style={{ color: '#9933ff', fontSize: 11, marginTop: 12 }}>
                  Earn 20% per cycle · Rebirth &amp; repeat
                </div>
                <div className="d-flex justify-content-end mt-3">
                  <Button
                    size="sm"
                    style={{ background: accent, border: 'none', color: '#000', fontWeight: 600 }}
                  >
                    View
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

      </Container>
    </div>
  );
};

export default Dashboard;
